import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';
import { buildPermissionsFromRouter } from '../helper/permissionsHelper';
import { helenaRoutes as helenaAgendaRoute } from './dashboard/agenda/routes'; // remove this line after migrating back from helena
import { routes as helenaMedicalRecordRoute } from './dashboard/medicalRecordHelena/routes'; // remove this line after migrating back from helena
import { routes as helenaPatientManagementRoute } from './dashboard/patientManagementHelena/routes'; // remove this line after migrating back from helena
import { publicRoutes as publicManagementChartsRoutes } from './dashboard/managementCharts/routes';
import { recruitmentRoutes as publicRecruitmentRoutes } from './public/recruitmentModule/routes';
import { helenaEmbedAllowsRoute } from '../helper/helenaEmbedAuth';
import { clearBrowserSessionCookies } from '../store/utils/api';

const routes = [
  ...publicManagementChartsRoutes,
  ...publicRecruitmentRoutes,
  ...dashboard.routes,
  ...helenaAgendaRoute,
  ...helenaMedicalRecordRoute,
  ...helenaPatientManagementRoute,
]; // remove helena routes after migrating back from helena

export const router = createRouter({ history: createWebHistory(), routes });
export const routesWithPermissions = buildPermissionsFromRouter(routes);

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    window.location.assign('/app/login');
    return '';
  }

  if (!to.name) {
    return next(frontendURL(`accounts/${user.account_id}/dashboard`));
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const rejectHelenaEmbedLeavingApp = to => {
  if (helenaEmbedAllowsRoute(to)) return false;

  clearBrowserSessionCookies();
  window.location.assign('/app/login');
  return true;
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach(async (to, _from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });
    // remove this if after migrating back from helena
    if (rejectHelenaEmbedLeavingApp(to)) return;

    const isPublicRoute = to.matched.some(r => r.meta?.public);
    if (isPublicRoute) {
      try {
        await store.dispatch('setUser');
      } catch (error) {
        // Ignore auth error on public routes to ensure strict isolation
      }
      return next();
    }

    await userAuthentication;
    return validateAuthenticateRoutePermission(to, next);
  });
};

export default router;
